import ForceLogout from '../../components/ForceLogout/ForceLogout';
import { getHeaderSidBarNovo, isAuthenticated, setTelaAberta } from './auth';
import NotFound from '../../components/NotFound/NotFound';

const ProtectedRoute = ({ children, escopoAcesso, modulo, contexto, ignorarEscopo = false }) => {
  const validacaoEscopo =
    (escopoAcesso &&
      escopoAcesso[modulo] &&
      escopoAcesso[modulo].rota &&
      escopoAcesso[modulo].rota[contexto]) ||
    ignorarEscopo;

  if (isAuthenticated() && modulo && contexto && !getHeaderSidBarNovo()) {
    setTelaAberta(`/${modulo}/${contexto}`);
  }

  return (
    <>
      {isAuthenticated() && (
        <>
          {validacaoEscopo && children}
          {!validacaoEscopo && <NotFound escopoAcesso={escopoAcesso} />}
        </>
      )}

      {!isAuthenticated() && <ForceLogout redirectTo="login" />}
    </>
  );
};
export default ProtectedRoute;
